import Swiper from "swiper/bundle";

class ExQuotesGallery {
  constructor(args = { sectionsContainer: document }) {
    this.sectionsContainer = args.sectionsContainer;
    this.sliderGallerySections = Array.from(this.sectionsContainer.getElementsByClassName("ex-quotes"));
    this.swiperInstances = [];
    if (this.sliderGallerySections != null) {
      this.initializeSwiper();
      //this.addResizeListener();
    } else {
      this.instance = null;
    }
  }

  initializeSwiper() {
    //console.log(this.sliderGallerySections);
    if (!this.sliderGallerySections[0]) {
      return;
    }
    
    console.log(this.sliderGallerySections[0]);

    this.sliderGallerySections.forEach((section) => {
      const swiperContainer = section.querySelector(".swiper-container");
      this.swiperInstances.push(new Swiper(swiperContainer, {
          grabCursor: true,
          loop: false,
          slidesPerView: 1,
          //centeredSlides: true,
          spaceBetween: 50,
          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          }
      }));
    });
    //console.log(this.swiperInstances);
  }

  /*addResizeListener() {
    window.addEventListener('resize', () => {
      if (this.swiperInstances) {
        this.swiperInstances.forEach((instance) => {
          instance.params.slidesPerView = this.getSlidesPerView();
          instance.update();
        });
      }
    });
  }*/

  /*getSlidesPerView() {
    const width = window.innerWidth;
    if (width <= 576) {
      return 1.1;
    } else if (width <= 1024) {
      return 2.2;
    } else {
      return 3.2;
    }
  }*/
}

export default ExQuotesGallery;


